import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../appStore';
import { AudienceSourceType } from '../../models';
import { defaultAudiencePageRange } from '../../services/AudienceAPI';
import { ActionCreators as AudienceActionCreators } from '../../store/AudienceListStore';
import { fetchHrisAttributes, fetchHrisAttributeValues, fetchPersonAttributes } from '../../store/BranchingLogicAttributesSlice';

export const useBranchingLogicAttributes = () => {
	const dispatch = useAppDispatch();
	const { attributes } = useAppSelector((state) => state.questionBranchingLogicAttributes);
	const needsAttributes = attributes === undefined;
	const { audienceSource, survey } = useAppSelector((state) => state.survey.surveyEditModel);
	const audienceSourceType = audienceSource.audienceSourceType;
	const hrisId = audienceSource.externalHrisId;
	const { surveyId, clientId } = survey;

	// personAttributes values are pulled with the attributes so we only need this for Hris attribute values
	const needsAttributeValues =
		attributes &&
		attributes instanceof Array &&
		attributes.some((a) => a.values.length === 0) &&
		audienceSourceType === AudienceSourceType.Hris &&
		hrisId;

	useEffect(() => {
		if (needsAttributes) {
			if (audienceSourceType === AudienceSourceType.Hris && hrisId) {
				dispatch(fetchHrisAttributes(hrisId));
			}

			if (audienceSourceType === AudienceSourceType.FileUpload) {
				dispatch(AudienceActionCreators.GetPagedAudiences(surveyId, defaultAudiencePageRange)).then(() => {
					dispatch(fetchPersonAttributes({ surveyId, clientId }));
				});
			}
		}

		if (needsAttributeValues) {
			dispatch(fetchHrisAttributeValues(hrisId));
		}
	}, [dispatch, needsAttributes, needsAttributeValues, hrisId, audienceSourceType, surveyId, clientId]);

	return useAppSelector((state) => state.questionBranchingLogicAttributes);
};

export default useBranchingLogicAttributes;
